// extracted by css-extract-rspack-plugin
export default {"textarea":"XP8cqo"};